<template>
  <v-row no-gutters>
    <!--HORNEADAS SM-UP -->
    <v-col v-if="$vuetify.breakpoint.smAndUp" cols="12" sm="6" class="pa-0">
      <v-img height="300" eager src="@/assets/img/horneadas2.jpeg" />
    </v-col>

    <v-col v-if="$vuetify.breakpoint.smAndUp"
           cols="12" sm="6"
           class="d-flex flex-column text-center justify-center align-center horneadas "
    >
      <v-icon class="yellow--text mb-5" size="92">local_fire_department</v-icon>
      <h2 class="text-h2 font-weight-bold">HORNEADAS</h2>
      <p class="px-2">No queres hacer nada, solo entrarle a morir a unas empandas <b>tremendas</b></p>
    </v-col>

    <!--HORNEADAS XS -->
    <v-col v-if="$vuetify.breakpoint.xsOnly"
           cols="12" sm="6"
           class="d-flex flex-column text-center justify-center align-center horneadas  py-4"
    >
      <v-icon class="yellow--text mb-5" size="92">local_fire_department</v-icon>
      <h3 class="text-h4 font-weight-bold">HORNEADAS</h3>
      <p class="px-2">No queres hacer nada, solo entrarle a morir a unas empandas <b>tremendas</b></p>
    </v-col>

    <v-col v-if="$vuetify.breakpoint.xsOnly" cols="12" sm="6" class="pa-0">
      <v-img height="300" eager src="@/assets/img/horneadas2.jpeg" />
    </v-col>

    <!--CONGELADAS SM-UP-->
    <v-col v-if="$vuetify.breakpoint.smAndUp"
           cols="12" sm="6"
           class="d-flex flex-column justify-center align-center flex-column congeladas"
    >
      <v-icon class="white--text mb-5" size="92">ac_unit</v-icon>
      <h2 class="text-h2 font-weight-bold">CONGELADAS</h2>
      <p class="px-2">Crudas, listas para hornear cuando quieras!</p>
      <p><a class="white--text" target="_blank" href="/img/InstructivoCongeladas.jpg">Como hornearlas</a></p>
    </v-col>

    <v-col v-if="$vuetify.breakpoint.smAndUp" cols="12" sm="6" class="pa-0">
      <v-img height="300" eager src="@/assets/img/congeladas2.jpeg" />
    </v-col>

    <!--CONGELADAS XS-->
    <v-col v-if="$vuetify.breakpoint.xsOnly"
           cols="12" sm="6"
           class="d-flex flex-column text-center justify-center align-center flex-column congeladas py-4"
    >
      <v-icon class="white--text mb-5" size="92">ac_unit</v-icon>
      <h3 class="text-h4 font-weight-bold">CONGELADAS</h3>
      <p class="px-2">Crudas, listas para hornear cuando quieras!</p>
      <p><a class="white--text" target="_blank" href="/img/InstructivoCongeladas.jpg">Como hornearlas</a></p>
    </v-col>

    <v-col v-if="$vuetify.breakpoint.xsOnly" cols="12" sm="6" class="pa-0">
      <v-img height="300" eager src="@/assets/img/congeladas2.jpeg" />
    </v-col>

  </v-row>
</template>

<script>
export default {
  name: "HorneadasCongeladas"
}
</script>

<style scoped>
.horneadas{
  background: rgb(236,57,57);
  background: radial-gradient(circle, rgba(236,57,57,1) 0%, rgba(168,34,34,1) 100%);
  color: yellow;
}

.congeladas{
  background: rgb(67,165,181);
  background: radial-gradient(circle, rgba(67,165,181,1) 0%, rgba(53,56,70,1) 100%);
  color: white;
}

</style>
